import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss'],
})
export class ImageViewComponent implements OnInit {
  @Input() path:string=''
  @Input() title?:string=''
  constructor(private modalController:ModalController) { }

  ngOnInit() {}
  close(){
    this.modalController.dismiss();
   }
   ngOnDestroy() {
  }
}
